import az900Logo from "../images/cert/az-900-small.webp";
import dp100Logo from "../images/cert/dp-100-small.webp";
import aceLogo from "../images/cert/gcp_ace-small.webp";

const certifications = {
  en: {
    lang: "en",
    title: "Certifications & Credentials",
    categories: [
      {
        title: "Microsoft Azure Certifications",
        certifications: [
          {
            name: "Microsoft Certified: Azure Fundamentals",
            code: "AZ-900",
            issuer: "Microsoft",
            date: "Aug 19, 2024",
            validUntil: null,
            credentialId: "2DD81A7D012295C7",
            verificationUrl:
              "https://learn.microsoft.com/api/credentials/share/en-gb/OleMichaelEkornrud-6927/2DD81A7D012295C7?sharingId=C8FEF970E060FF46",
            description:
              "Demonstrates foundational level knowledge of cloud services and how those services are provided with Microsoft Azure, including core Azure services, general security, and compliance features.",
            skills: [
              "Cloud Concepts",
              "Core Azure Services",
              "Azure Pricing",
              "Security & Compliance",
              "Azure Support",
              "Azure Governance",
              "Azure Management Tools",
              "Service Level Agreements",
            ],
            logo: az900Logo,
            status: "active",
          },
          {
            name: "Microsoft Certified: Azure Data Fundamentals",
            code: "DP-900",
            issuer: "Microsoft",
            date: "May 9, 2025",
            validUntil: null,
            credentialId: "34A2510633982E51",
            verificationUrl:
              "https://learn.microsoft.com/api/credentials/share/en-gb/OleMichaelEkornrud-6927/34A2510633982E51?sharingId=C8FEF970E060FF46",
            description:
              "Demonstrates foundational knowledge of core data concepts and related Microsoft Azure data services, including relational and non-relational data, big data, and analytics.",
            skills: [
              "Core Data Concepts",
              "Azure Storage",
              "Azure SQL Database",
              "Azure Cosmos DB",
              "Data Analytics",
              "Azure Synapse Analytics",
              "Power BI",
              "Data Visualization",
            ],
            logo: az900Logo,
            status: "active",
          },
          {
            name: "Microsoft Certified: Azure Data Scientist Associate",
            code: "DP-100",
            issuer: "Microsoft",
            date: null,
            validUntil: null,
            credentialId: null,
            verificationUrl: null,
            description:
              "Validates skills in designing, building, testing, and maintaining data science solutions on Microsoft Azure.",
            skills: [
              "Data Science",
              "Machine Learning",
              "Data Analysis",
              "Model Deployment",
            ],
            logo: dp100Logo,
            status: "pending",
          },
        ],
      },
      {
        title: "Google Cloud Certifications",
        certifications: [
          {
            name: "Google Cloud Certified: Associate Cloud Engineer",
            code: "ACE",
            issuer: "Google",
            date: "Feb 18, 2026",
            validUntil: "Feb 18, 2029",
            credentialId: "5c5fcc31f9604dc690205673b057da2f",
            verificationUrl:
              "https://www.credly.com/badges/dda8548c-d9a4-408c-975f-58106b589e18/public_url",
            description:
              "Validates the ability to deploy applications, monitor operations, and manage enterprise solutions on Google Cloud.",
            skills: [
              "Google Cloud Platform",
              "Cloud Deployment",
              "Monitoring",
              "Management",
            ],
            logo: aceLogo,
            status: "active",
          },
        ],
      },
      /*{
        title: 'Microsoft Applied Skills',
        certifications: [
            {
            name: 'Deploy and configure Azure Monitor',
            code: 'Applied Skills',
            issuer: 'Microsoft',
            date: 'Example: Feb 2024',
            validUntil: null,
            credentialId: 'Your-Applied-Skills-ID',
            verificationUrl: 'https://learn.microsoft.com/en-us/credentials/applied-skills/',
            description: 'Demonstrates ability to deploy and configure Azure Monitor to collect, analyze, and act on telemetry data.',
            skills: ['Azure Monitor', 'Log Analytics', 'Application Insights', 'Alerts', 'Dashboards'],
            logo: '📊',
            status: 'active'
          }
        ]
      }*/
    ],
  },
  no: {
    lang: "no",
    title: "Sertifiseringer",
    categories: [
      {
        title: "Microsoft Azure Sertifiseringer",
        certifications: [
          {
            name: "Microsoft Certified: Azure Fundamentals",
            code: "AZ-900",
            issuer: "Microsoft",
            date: "19 aug 2024",
            validUntil: null,
            credentialId: "2DD81A7D012295C7",
            verificationUrl:
              "https://learn.microsoft.com/api/credentials/share/en-gb/OleMichaelEkornrud-6927/2DD81A7D012295C7?sharingId=C8FEF970E060FF46",
            description:
              "Demonstrerer grunnleggende kunnskap om sky-tjenester og hvordan disse tjenestene leveres med Microsoft Azure, inkludert kjernetjenester, generell sikkerhet og compliance-funksjoner.",
            skills: [
              "Sky-konsepter",
              "Kjerne Azure-tjenester",
              "Azure-prissetting",
              "Sikkerhet & Compliance",
              "Azure Support",
              "Azure Governance",
              "Azure Management-verktøy",
              "Service Level Agreements",
            ],
            logo: az900Logo,
            status: "active",
          },
          {
            name: "Microsoft Certified: Azure Data Fundamentals",
            code: "DP-900",
            issuer: "Microsoft",
            date: "9 mai 2025",
            validUntil: null,
            credentialId: "34A2510633982E51",
            verificationUrl:
              "https://learn.microsoft.com/api/credentials/share/en-gb/OleMichaelEkornrud-6927/34A2510633982E51?sharingId=C8FEF970E060FF46",
            description:
              "Demonstrerer grunnleggende kunnskap om kjerne datakonsepter og relaterte Microsoft Azure datatjenester, inkludert relasjonelle og ikke-relasjonelle data, big data og analytics.",
            skills: [
              "Kjerne datakonsepter",
              "Azure Storage",
              "Azure SQL Database",
              "Azure Cosmos DB",
              "Data Analytics",
              "Azure Synapse Analytics",
              "Power BI",
              "Datavisualisering",
            ],
            logo: az900Logo,
            status: "active",
          },
          {
            name: "Microsoft Certified: Azure Data Scientist Associate",
            code: "DP-100",
            issuer: "Microsoft",
            date: null,
            validUntil: null,
            credentialId: null,
            verificationUrl: null,
            description:
              "Validerer ferdigheter i å designe, bygge, teste og vedlikeholde data science-løsninger på Microsoft Azure.",
            skills: [
              "Data Science",
              "Machine Learning",
              "Dataanalyse",
              "Modell-deployment",
            ],
            logo: dp100Logo,
            status: "pending",
          },
        ],
      },
      {
        title: "Google Cloud Sertifiseringer",
        certifications: [
          {
            name: "Google Cloud Certified: Associate Cloud Engineer",
            code: "ACE",
            issuer: "Google",
            date: "Feb 18, 2026",
            validUntil: "Feb 18, 2029",
            credentialId: "5c5fcc31f9604dc690205673b057da2f",
            verificationUrl:
              "https://www.credly.com/badges/dda8548c-d9a4-408c-975f-58106b589e18/public_url",
            description:
              "Validerer evnen til å distribuere applikasjoner, overvåke operasjoner og administrere bedriftsløsninger på Google Cloud.",
            skills: [
              "Google Cloud Platform",
              "Cloud Deployment",
              "Monitoring",
              "Management",
            ],
            logo: aceLogo,
            status: "active",
          },
        ],
      },
      /*{
        title: 'Microsoft Applied Skills',
        certifications: [
          {
            name: 'Deploy and configure Azure Monitor',
            code: 'Applied Skills',
            issuer: 'Microsoft',
            date: 'Eksempel: Feb 2024',
            validUntil: null,
            credentialId: 'Din-Applied-Skills-ID',
            verificationUrl: 'https://learn.microsoft.com/en-us/credentials/applied-skills/',
            description: 'Demonstrerer evne til å distribuere og konfigurere Azure Monitor for å samle inn, analysere og reagere på overvåkingsdata.',
            skills: ['Azure Monitor', 'Log Analytics', 'Application Insights', 'Varsler', 'Dashboards'],
            logo: '📊',
            status: 'active'
          }
        ]
      }*/
    ],
  },
};

export default certifications;
